import {
  getAllIndications,
  getAllProviderTypes,
  get_providers,
  getProvidersListForFilters,
  getRfiListForFilters,
  searchProvider,
  searchRfiTemplates,
  getAllCompanySize,
  getAnnualRevenueRange,
  exportProvider,
  getExportLogs,
  getExportFiles,
  getProviderBasicProfile,
  getProviderCompanyProfile,
  getProviderAttachments,
  getAttachmentFiles,
  getProviderDocuments,
  DocumentsBookmark,
  requestAccess,
  getRequestBookmarkDetail,
  getAssessmentDocuments,
  getAllDocumentsList,
  getVendorLibraryServiceCategories,
  advancedSearch,
  getAllDocumentsRequestList,
  getAllDocumentsRequestListAllPages,
  providerRequestApprove,
  getLibraryRequestDetails,
  getLibraryRequestPreview,
  providerRequestReject,
  getAllDocumentsRequestListAdmin,
  archiveDocumentRequest,
  unarchiveDocumentRequest,
  archiveDocument,
  unarchiveDocument,
  getDocumentActivity,
  archiveSponsorRfi,
  unarchiveSponsorRfi,
  archiveVqaRequest,
  unarchiveVqaRequest,
  getDocumentDetails,
  postAssessmentsRequests,
  getAuditorsForFilters,
  getAllVQAList,
  getAllVQAListAllPages,
  getAllVQAListAdmin,
  getVQAActivity,
  getVQADetails,
  adminRequestApprove,
  adminRequestReject,
  createDocument,
  getBlobSasToken,
  uploadFileToBlob,
  getDocumentFiles,
  addActivity,
  VQASponsorContactAdmin,
  VQAProviderContactAdmin,
  VQAAssessmentOverviewAdmin,
  createAuditor,
  getAuditorDetails,
  updateAuditor,
  deleteAuditor,
  getProvidersListForProviderDetails,
  updateBackendAssessmentDetails,
  getAllVQAListAdminRequest,
  getVQARequestDetailsAdmin,
  getVQADetailsAdmin,
  getAdditionalScopeOptions,
  getAssessmentDetails,
  getAssessmentRequestContactsByVqa,
  getJoinVAQDetails,
  getAllDocumentFiles,
  joinVqaRequest,
  getVQAParticipantsList,
  getJoinVAQRequestDetails,
  getJoinVQARequestDetailsAdmin,
  confirmAddOnScope,
  updateJoinVqaScope,
  acceptVqaRequest,
  getAllAssessmentsForCalendar,
  rejectVqaRequest,
  getAllRequestedAssesmentList,
  getAssesmentRequestDetails,
  generateQuestionnaire,
  getInitialBotResponse,
  sendQuestionResponse,
  generateAudit,
  addBackendUser,
  getAllBackendUserList,
  getBackendUserDetails,
  updateBackendUser,
  getAllSponsorUserList,
  getSponsorUserDetails,
  addSponsorUser,
  updateSponsorUser,
  updateMyProfile,
  getMyProfile,
  updateBackendUserMfaStatus,
  getSponsorMasterUsers,
  getSponsorMasterUserDetails,
  addSponsorMasterUser,
  updateSponsorMasterUser,
  getSponsorUserProfile,
  updateSponsorUserMfaStatus,
  getSponsorMasterUserProfile,
  updateSponsorUserProfile,
  updateSponsorMasterUserProfile,
  getProviderMasterUsers,
  createProviderMasterUser,
  deleteBackendUser,
  getProviderMasterUserDetails,
  deleteProviderMasterUser,
  updateProviderMasterUser,
  deleteSponsorMasterUser,
  deleteSponsorUser,
  getVQAActivityBeforeAccepting,
  CheckEmailConfirmed,
  getAllSponsorsList,
  CancelAssessment,
  getAllSponsorsForAdmin,
  getParentSponsorDetails,
  createSponsor,
  createSponsorAdminDualRole,
  getProvidersPaginated,
  createProvider,
  updateProviderBasicProfile,
  updateProviderCompanyProfile,
  updateProviderEmail,
  deleteSponsorUserDetails,
  getSponsorDetails,
  getSponsorsDetails,
  updateSponsorUserDetails,
  getAllSponsorUsersList,
  userMetrics,
  listPurchaserVendors,
  listOfQuestionnaireTemplate,
  listOfQuestionnaireTemplateForAdmin,
  createPurchaseVendors,
  sendRfiToPurchaseVendor,
  getRfis,
  getMyRfisAllPages,
  getAdminRfisAllPages,
  getProvidersLocation,
  getRFIsDetails,
  updateVqqVendorContacts,
  updateVqqSponsorContacts,
  resendVqqContactInvites,
  updateVqaVendorContacts,
  updateVqaSponsorContacts,
  resendVqaContactInvites,
  getRfiSnapshot,
  getRfiScoredSnapshot,
  getRiskMethodology,
  patchSmeOverride,
  publishRunWithValidation,
  unpublishRun,
  listCustomRiskModels,
  getCustomRiskModel,
  createCustomRiskModel,
  updateCustomRiskModel,
  deleteCustomRiskModel,
  syncRubricFromAirtable,
  getAvailableRiskModelsForVqq,
  selectRiskModelForVqq,
  previewRiskModelForVqq,
  listDiligentRiskTemplates,
  listTemplateQuestions,
  updateDiligentTemplateQuestions,
  getRiskSummariesByIds,
  postRequestRemediation,
  getRfisAdmin,
  sponsorRFIMetrics,
  providerTotalCount,
  totalAssessment,
  getClientSecrets,
  assessmentMetrics,
  resendQuestionnaire,
  activateQuestionnaire,
  cancelQuestionnaireRequest,
  getPurchaseVendorBySponsor,
  getRFIActivity,
  getVendorRfis,
  getVendorRfisAllPages,
  sponsorTotalCount,
  providerAssessmentMetrics,
  providerRFIMetrics,
  totalRFIs,
  providerLanguages,
  providerAffiliatedOrganization,
  providerGeographicRegion,
  providerCertifications,
  providerDiversityClassification,
  createProviderUser,
  createProviderDualRole,
  createProviderDualRoleFromProvider,
  getAllProviderOrg,
  getAllProviderUsers,
  getProviderOrgDetails,
  getProvidersListForProviderUserDetails,
  getProvidersListForTherapeutic,
  getProviderDetailsWithUsers,
  getProviderAllData,
  updateProviderOrg,
  getSponsorsFilter,
  acceptVendorQuestionnaire,
  exportQuestionnaireExcel,
  getSupportingDocumentCount,
  getExportStatus,
  downloadExportFile,
  getFirstTimeSignin,
  downloadExportDocs,
  getLegacyAttachmentAvailability,
  acceptTerms,
  getVendorsMe,
  updateProviderUserProfile,
  updateProviderUserMfaStatus,
  hypercomplyLogout,
  supportingDocsExportVQA,
  checkProvidersRequiredFields,
  updateProviderUser,
  updateProviderUserRolesPermissions,
  updateProviderUserRolesPermissionsForProvider,
  getSponsorCount,
  getProviderCounts,
  getProviderDocumentCountsByIds,
  getRfiResponse,
  getRfiResponseFile,
  getTAIndicationsData,
  updateTokenRole,
  getTASummaryData,
  getChatHistory,
  sendChat,
  updateChatName,
  getChatMessages,
  addProviderContact,
  addProviderLocation,
  getAllProviderUsersByProviderId,
  makeRequestContact,
  makePrimaryContact,
  activateOrDeactivateProviderUserContact,
  activateOrDeactivateSponsorUserContact,
  hideOrShowFromDiscovery,
  activateOrDeactivateProvider,
  getRequestMetrics,
  activateOrDeactivateSponsor,
  getAutoreleaseEligibility,
  postAutorelease,
  getMyVendors,
  addManualMyVendor,
  removeManualMyVendor,
  hideMyVendor,
  unhideMyVendor,
  getBookmarkedVendors,
  addBookmarkedVendor,
  removeBookmarkedVendor,
  getSponsorVendorTags,
  getVendorTagsForProvider,
  setVendorTagsForProvider,
  getSponsorNotificationUsers,
  setSponsorNotificationUsers,
  getVendorLists,
  createVendorList,
  updateVendorList,
  duplicateVendorList,
  addVendorListMembers,
  deleteVendorList,
  removeVendorListMember,
  reorderVendorListMembers,
  getSystemListMemberOrder,
  reorderSystemListMembers,
  listOpenVqqRequestsForProvider,
} from "../api/api-methods";
import { useMutation, useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useCheckEmailConfirmed = (role) => {
  return useQuery({
    queryKey: ["emailVerify"], // No need to include role in queryKey
    queryFn: CheckEmailConfirmed, // Call API function directly without arguments
    staleTime: 0,
    cacheTime: 0,
    enabled: ["Backend User", "Backend Master User"].includes(role), // Cleaner condition
  });
};

export const useGetprovidersListForFilters = ({ hideDiscoveryStatus = false } = { hideDiscoveryStatus: false }) => {
  return useQuery({
    queryKey: ["providers"],
    queryFn: () => getProvidersListForFilters({ hideDiscoveryStatus }),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const useGetSponsorListForFilters = () => {
  return useQuery({
    queryKey: ["sponsorsFilters"],
    queryFn: () => getAllSponsorsList(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const UseGetRfiListForFilters = () => {
  return useQuery({
    queryKey: ["Rfis"],
    queryFn: () => getRfiListForFilters(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useDebouncedSearchProviders = (debouncedSearchText) => {
  return useQuery({
    queryKey: ["providers", debouncedSearchText],
    queryFn: () => searchProvider(debouncedSearchText),
    enabled: debouncedSearchText.length > 1,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const useDebouncedSearchRfiTemplates = (debouncedSearchText) => {
  return useQuery({
    queryKey: ["rfi_templates", debouncedSearchText],
    queryFn: () => searchRfiTemplates(debouncedSearchText),
    enabled: debouncedSearchText.length > 1,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useGetAllIndications = () => {
  return useQuery({
    queryKey: ["indications"],
    queryFn: getAllIndications,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useGetAllProviderTypes = () => {
  return useQuery({
    queryKey: ["provider-types"],
    queryFn: getAllProviderTypes,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const useGetAllCompanySize = () => {
  return useQuery({
    queryKey: ["company-size"],
    queryFn: getAllCompanySize,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const useGetAllAnualRevenueRange = () => {
  return useQuery({
    queryKey: ["revenue-range"],
    queryFn: getAnnualRevenueRange,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const useExport = () => {
  return useMutation({
    mutationFn: (body) => exportProvider(body),
  });
};

export const useExportLogs = (currentPage) => {
  return useQuery({
    queryKey: ["export-logs", currentPage],
    queryFn: () => getExportLogs(currentPage), // Pass a function
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useExportFile = () => {
  return useMutation({
    mutationFn: (id) => getExportFiles(id),
  });
};

export const useGetProviderBasicProfile = (id) => {
  return useQuery({
    queryKey: ["provider-basic-profile", id],
    queryFn: () => getProviderBasicProfile(id),
    enabled: !!id,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useGetProviderCompanyProfile = (id) => {
  return useQuery({
    queryKey: ["provider-company-profile", id],
    queryFn: () => getProviderCompanyProfile(id),
    enabled: !!id,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useGetProviderAttachments = (id) => {
  return useQuery({
    queryKey: ["attachments", id],
    queryFn: () => getProviderAttachments(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useAttachmentFile = () => {
  return useMutation({
    mutationFn: (id, attachmentId) => getAttachmentFiles(id, attachmentId),
  });
};

export const useGetProviderDocuments = (id) => {
  return useQuery({
    queryKey: ["provider_documents", id],
    queryFn: () => getProviderDocuments(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const usePostDocumentsBookmarks = () => {
  return useMutation({
    mutationFn: (docId, docType) => DocumentsBookmark(docId, docType),
  });
};

export const usePostRequestAccess = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => {
      if (payload && typeof payload === "object") {
        return requestAccess(payload.documentId, payload.hcQuestionnaireId);
      }
      return requestAccess(payload);
    },
    onSuccess: (_data, payload) => {
      const docId =
        payload && typeof payload === "object" ? payload.documentId : payload;
      if (docId) {
        queryClient.invalidateQueries({ queryKey: ["documentDetails", docId] });
      }
    },
  });
};

export const useGetRequestBookmarkDetail = (id) => {
  return useQuery({
    queryKey: ["requestBookmark", id],
    queryFn: () => getRequestBookmarkDetail(id),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useGetAssessmentDocuments = (currentPage) => {
  return useQuery({
    queryKey: ["AssessmentDocuments", currentPage],
    queryFn: () => getAssessmentDocuments(currentPage),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useGetAllDocumentsList = (
  currentPage,
  searchQuery,
  docType,
  provider,
  status,
  services,
  vqaId,
  entityId,
  service_names,
  discoveryStatus = null,
  archiveStatusFilter = null,
  sortOptions = {},
  locationFilterParams = null,
  /** Bumps on each header sort click so asc→desc→asc does not reuse a stale query entry. */
  sortFetchNonce = 0,
  enabled = true,
  orgLibraryView = false
) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDir = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: [
      "allDocumentsList",
      currentPage,
      searchQuery,
      docType,
      provider,
      status,
      services,
      vqaId,
      entityId,
      service_names,
      discoveryStatus,
      archiveStatusFilter,
      sortBy,
      sortDir,
      locationFilterParams,
      sortFetchNonce,
      orgLibraryView,
    ],
    queryFn: () =>
      getAllDocumentsList(
        currentPage,
        searchQuery,
        docType,
        provider,
        status,
        services,
        vqaId,
        entityId,
        service_names,
        undefined,
        discoveryStatus,
        archiveStatusFilter,
        sortOptions?.orderBy != null &&
          sortOptions?.orderBy !== "" &&
          (sortOptions?.sortDirection === "asc" ||
            sortOptions?.sortDirection === "desc")
          ? {
              orderBy: sortOptions.orderBy,
              sortDirection: sortOptions.sortDirection,
            }
          : {},
        locationFilterParams,
        orgLibraryView
      ),
    staleTime: 60 * 1000,
    gcTime: 30 * 60 * 1000,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled,
  });
};

export const useVendorLibraryServiceCategories = (providerId) => {
  return useQuery({
    queryKey: ["vendorLibraryServiceCategories", providerId],
    queryFn: () => getVendorLibraryServiceCategories(providerId),
    enabled: Boolean(providerId),
    staleTime: 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

/**
 * Reports panel of an assessment: POST /Documents with `entity_id` set, which the backend
 * routes to GetAllVQAReportsByEntityId (Draft / Final / Observation / CAPA reports).
 * Disabled until the id is known so the request never fires unfiltered (Bug 14601: a null id
 * returned the first page of the whole library). `refetch()` still works while disabled.
 */
export const useGetAssessmentReports = (entityId) =>
  useGetAllDocumentsList(
    1,
    null,
    null,
    null,
    null,
    null,
    null,
    entityId ?? null,
    undefined,
    undefined,
    undefined,
    undefined,
    null,
    0,
    !!entityId
  );

export const useAdvancedSearch = (currentPage, searchQuery) => {
  return useQuery({
    queryKey: ["Poc", currentPage, searchQuery],
    queryFn: () => advancedSearch(currentPage, searchQuery),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

/** Library Requests: all provider document requests (no filters) to populate the Services dropdown with only options the user has. */
export const useGetAllDocumentsRequestListAllPagesForServicesFilter = () => {
  return useQuery({
    queryKey: ["allDocumentsRequestListAllPagesForServicesFilter"],
    queryFn: () => getAllDocumentsRequestListAllPages(100),
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

export const useGetAllDocumentsRequestList = (
  currentPage,
  docType,
  provider,
  status,
  services,
  bookmark,
  searchQuery,
  sponsor_id_list,
  service_names,
  sortOptions,
  /** Bumps on each header sort click so asc→desc→asc does not reuse a stale query entry. */
  sortFetchNonce = 0,
  orgLibraryView = false,
  enabled = true
) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDir = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: [
      "allDocumentsRequestList",
      currentPage,
      docType,
      provider,
      status,
      services,
      bookmark,
      searchQuery,
      sponsor_id_list,
      service_names,
      sortBy,
      sortDir,
      sortFetchNonce,
      orgLibraryView,
    ],
    queryFn: ({ queryKey }) => {
      const [
        _key,
        page,
        dt,
        prov,
        st,
        svc,
        bm,
        sq,
        sponsors,
        svcNames,
        orderBy,
        sortDirection,
        _sortNonce,
        orgLibView,
      ] = queryKey;
      const builtSort =
        orderBy != null &&
        orderBy !== "" &&
        (sortDirection === "asc" || sortDirection === "desc")
          ? { orderBy, sortDirection }
          : {};
      return getAllDocumentsRequestList(
        page,
        dt,
        prov,
        st,
        svc,
        bm,
        sq,
        sponsors,
        svcNames,
        21,
        builtSort,
        orgLibView
      );
    },
    structuralSharing: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
    enabled,
  });
};

export const useRequestApproval = () => {
  return useMutation({
    mutationFn: (docId) => providerRequestApprove(docId),
  });
};
export const useRequestReject = () => {
  return useMutation({
    mutationFn: ({ id, reason }) => providerRequestReject(id, reason),
  });
};

export const useLibraryRequestDetails = (requestId, enabled = true) => {
  return useQuery({
    queryKey: ["libraryRequestDetails", requestId],
    queryFn: () => getLibraryRequestDetails(requestId),
    enabled: Boolean(requestId) && Boolean(enabled),
    staleTime: 0,
  });
};

export const useLibraryRequestPreview = (requestId, enabled) => {
  return useQuery({
    queryKey: ["libraryRequestPreview", requestId],
    queryFn: () => getLibraryRequestPreview(requestId),
    enabled: Boolean(requestId) && Boolean(enabled),
    staleTime: Infinity,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    structuralSharing: false,
  });
};

export const useArchiveDocumentRequest = () => {
  return useMutation({
    mutationFn: ({ requestId, archiveComment }) =>
      archiveDocumentRequest(requestId, archiveComment),
  });
};

export const useUnarchiveDocumentRequest = () => {
  return useMutation({
    mutationFn: (requestId) => unarchiveDocumentRequest(requestId),
  });
};

export const useArchiveDocument = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ documentId, archiveComment }) =>
      archiveDocument(documentId, archiveComment),
    onSuccess: (_data, { documentId }) => {
      queryClient.invalidateQueries({ queryKey: ["documentActivity", documentId] });
      queryClient.invalidateQueries({ queryKey: ["allDocumentsList"] });
      queryClient.invalidateQueries({ queryKey: ["allDocumentsRequestListadmin"] });
      queryClient.invalidateQueries({ queryKey: ["allDocumentsRequestList"] });
      queryClient.invalidateQueries({ queryKey: ["documentDetails", documentId] });
    },
  });
};

export const useUnarchiveDocument = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ documentId, archiveComment }) =>
      unarchiveDocument(documentId, archiveComment),
    onSuccess: (_data, { documentId }) => {
      queryClient.invalidateQueries({ queryKey: ["documentActivity", documentId] });
      queryClient.invalidateQueries({ queryKey: ["allDocumentsList"] });
      queryClient.invalidateQueries({ queryKey: ["allDocumentsRequestListadmin"] });
      queryClient.invalidateQueries({ queryKey: ["allDocumentsRequestList"] });
      queryClient.invalidateQueries({ queryKey: ["documentDetails", documentId] });
    },
  });
};

export const useGetDocumentActivity = (documentId, enabled = true) => {
  return useQuery({
    queryKey: ["documentActivity", documentId],
    queryFn: () => getDocumentActivity(documentId),
    enabled: Boolean(documentId) && enabled,
    staleTime: 0,
  });
};

export const useArchiveSponsorRfi = () => {
  return useMutation({
    mutationFn: ({ sponsorRfiResponseId, archiveComment }) =>
      archiveSponsorRfi(sponsorRfiResponseId, archiveComment),
  });
};

export const useUnarchiveSponsorRfi = () => {
  return useMutation({
    mutationFn: (sponsorRfiResponseId) => unarchiveSponsorRfi(sponsorRfiResponseId),
  });
};

export const useArchiveVqaRequest = () => {
  return useMutation({
    mutationFn: ({ vqaRequestId, archiveComment }) =>
      archiveVqaRequest(vqaRequestId, archiveComment),
  });
};

export const useUnarchiveVqaRequest = () => {
  return useMutation({
    mutationFn: (vqaRequestId) => unarchiveVqaRequest(vqaRequestId),
  });
};

export const useGetAllDocumentsRequestListAdmin = (
  currentPage,
  docType,
  provider,
  status,
  services,
  service_names,
  sponsor_id_list,
  searchQuery = "",
  sortOptions,
  sortFetchNonce = 0,
  archiveStatusFilter = null,
  orgLibraryView = false,
  enabled = true
) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDir = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: [
      "allDocumentsRequestListadmin",
      currentPage,
      docType,
      provider,
      status,
      services,
      service_names,
      sponsor_id_list,
      searchQuery,
      sortBy,
      sortDir,
      sortFetchNonce,
      archiveStatusFilter,
      orgLibraryView,
    ],
    queryFn: ({ queryKey }) => {
      const [
        _key,
        page,
        dt,
        prov,
        st,
        svc,
        svcNames,
        sponsors,
        sq,
        orderBy,
        sortDirection,
        _sortNonce,
        archiveFilter,
        orgLibView,
      ] = queryKey;
      const builtSort =
        orderBy != null &&
        orderBy !== "" &&
        (sortDirection === "asc" || sortDirection === "desc")
          ? { orderBy, sortDirection }
          : {};
      return getAllDocumentsRequestListAdmin(
        page,
        dt,
        prov,
        st,
        svc,
        svcNames,
        sponsors,
        sq,
        21,
        builtSort,
        archiveFilter,
        orgLibView
      );
    },
    structuralSharing: false,
    staleTime: 0,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: "always",
    enabled,
  });
};

export const useGetDocumentDetails = (id) => {
  return useQuery({
    queryKey: ["documentDetails", id],
    queryFn: () => getDocumentDetails(id),
    enabled: !!id, // Prevents query execution when `id` is undefined or null
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const usePostAssessmentsRequests = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      providerId,
      providerType,
      isPrimaryLocationRequired,
      isSecondaryLocationRequired,
      secondaryLocationAddress,
      capabilities,
      desiredInitialDraftDate,
      additionalDetails,
      isMultiSponsorAssessment,
      providerName,
      providerMainContactName,
      providerMainContactEmail,
      providerUrl,
      providerAddress1,
      providerCity,
      providerZip,
      providerCountry,
      providerPhoneNumber,
      providerAdditionalAddresses,
      providerAddress2,
      providerState,
      vqaType,
      otherAddress,
      is_provider_new,
      provider_type,
      provider_contacts,
    }) =>
      postAssessmentsRequests(
        providerId,
        providerType,
        isPrimaryLocationRequired,
        isSecondaryLocationRequired,
        secondaryLocationAddress,
        capabilities,
        desiredInitialDraftDate,
        additionalDetails,
        isMultiSponsorAssessment,
        providerName,
        providerMainContactName,
        providerMainContactEmail,
        providerUrl,
        providerAddress1,
        providerCity,
        providerZip,
        providerCountry,
        providerPhoneNumber,
        providerAdditionalAddresses,
        providerAddress2,
        providerState,
        vqaType,
        otherAddress,
        is_provider_new,
        provider_type,
        provider_contacts
      ),
    // The My Assessments grid and the admin lists are served from these keys with a long
    // staleTime, so without this a sponsor already on the grid, or navigating back to it,
    // kept the pre-submit page until a full reload. Owning it here covers every submit
    // entry point at once.
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allvqalist"] });
      queryClient.invalidateQueries({ queryKey: ["allvqalistAllPages"] });
      queryClient.invalidateQueries({ queryKey: ["allvqalistadmin"] });
      queryClient.invalidateQueries({ queryKey: ["allvqalistadminrequest"] });
    },
    onError: (error) => { },
  });
};

export const useGetAuditorsListForFilters = () => {
  return useQuery({
    queryKey: ["auditors"],
    queryFn: () => getAuditorsForFilters(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useGetAllVQAList = (
  currentPage,
  auditor,
  provider,
  sponsor,
  status,
  services,
  vqaMonth,
  searchQuery,
  pageSize = 21,
  sortOptions,
  sortFetchNonce = 0
) => {
  return useQuery({
    queryKey: [
      "allvqalist",
      currentPage,
      auditor,
      provider,
      sponsor,
      status,
      services,
      vqaMonth,
      searchQuery,
      pageSize,
      sortOptions?.orderBy ?? null,
      sortOptions?.sortDirection ?? null,
      sortFetchNonce,
    ],
    queryFn: () =>
      getAllVQAList(
        currentPage,
        auditor,
        provider,
        sponsor,
        status,
        services,
        vqaMonth,
        searchQuery,
        pageSize,
        sortOptions || {}
      ),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

/** Fetches all pages of user assessments (no service filter) for building complete services dropdown */
export const useGetAllVQAListAllPages = (
  auditor,
  provider,
  sponsor,
  status,
  vqaMonth,
  searchQuery
) => {
  return useQuery({
    queryKey: [
      "allvqalistAllPages",
      auditor,
      provider,
      sponsor,
      status,
      vqaMonth,
      searchQuery,
    ],
    queryFn: () =>
      getAllVQAListAllPages(
        auditor,
        provider,
        sponsor,
        status,
        vqaMonth,
        searchQuery
      ),
    staleTime: 5 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  });
};

export const useGetAllAssessmentsForCalendar = (
  currentPage,
  auditorIdList,
  providerIdList,
  vqaStatus,
  rfiIdList,
  providerTypes,
  vqaMonth,
  providerType,
  assessmentType,
  searchQuery,
  sponsorIdList,
  calendarMonthSpan,
  extraFilters
) => {
  return useQuery({
    queryKey: [
      "assessmentsForCalendar",
      currentPage,
      auditorIdList,
      providerIdList,
      vqaStatus,
      rfiIdList,
      providerTypes,
      vqaMonth,
      providerType,
      assessmentType,
      searchQuery,
      sponsorIdList,
      calendarMonthSpan,
      extraFilters,
    ],
    queryFn: () =>
      getAllAssessmentsForCalendar(
        currentPage,
        auditorIdList,
        providerIdList,
        vqaStatus,
        rfiIdList,
        providerTypes,
        vqaMonth,
        providerType,
        assessmentType,
        searchQuery,
        sponsorIdList,
        calendarMonthSpan,
        extraFilters
      ),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useGetAllVQAListAdmin = (
  currentPage,
  auditor,
  provider,
  status,
  services,
  sponsor,
  search,
  sortOptions
) => {
  return useQuery({
    queryKey: [
      "allvqalistadmin",
      currentPage,
      auditor,
      provider,
      status,
      services,
      sponsor,
      search,
      sortOptions?.orderBy ?? null,
      sortOptions?.sortDirection ?? null,
    ],
    queryFn: () =>
      getAllVQAListAdmin(
        currentPage,
        auditor,
        provider,
        status,
        services,
        sponsor,
        search,
        sortOptions
      ),
    staleTime: 0,
    cacheTime: 0,
  });
};
export const useGetAllVQAListAdminRequest = (
  currentPage,
  provider,
  status,
  services,
  sponsor,
  search,
  sortOptions,
  sortFetchNonce,
  // Appended LAST so it can never shift any existing positional
  // arg — pageArgIndex/sponsorArgIndex are pinned by requestListStickyFilters.test.jsx.
  requestTypeList,
  auditorIdList
) => {
  return useQuery({
    queryKey: [
      "allvqalistadminrequest",
      currentPage,
      provider,
      status,
      services,
      sponsor,
      search,
      sortOptions?.orderBy ?? null,
      sortOptions?.sortDirection ?? null,
      sortFetchNonce ?? 0,
      requestTypeList ?? null,
      auditorIdList ?? null,
    ],
    queryFn: () =>
      getAllVQAListAdminRequest(currentPage, provider, status, services, sponsor, search, {
        sortOptions,
        requestTypeList,
        auditorIdList,
      }),
    structuralSharing: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
  });
};

export const useGetVQAActivity = (id) => {
  return useQuery({
    queryKey: ["vqaactivity", id],
    queryFn: () => getVQAActivity(id),
    enabled: !!id,
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useGetRFIActivity = (id) => {
  return useQuery({
    queryKey: ["rfiactivity", id],
    queryFn: () => getRFIActivity(id),
    enabled: !!id,
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useGetVQAActivityBeforeAccepting = (id) => {
  return useQuery({
    queryKey: ["vqaactivitybeforeaccepting", id],
    queryFn: () => {
      if (!id) return Promise.resolve(null); // Prevents execution if id is undefined
      return getVQAActivityBeforeAccepting(id);
    },
    enabled: !!id,
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useGetVQADetails = (id) => {
  return useQuery({
    queryKey: ["vqaDetails"],
    queryFn: () => getVQADetails(id),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useAdminRequestApproval = () => {
  return useMutation({
    mutationFn: (vqaId) => adminRequestApprove(vqaId),
  });
};
export const useAdminRequestReject = () => {
  return useMutation({
    mutationFn: ({ id, reason }) => adminRequestReject(id, reason),
  });
};

export const useUploadFileToBlob = () => {
  return useMutation({
    mutationFn: ({ file, blobSasUrl }) => uploadFileToBlob(file, blobSasUrl),
    onSuccess: (data) => { },
    onError: (error) => { },
  });
};

export const useCreateDocument = () => {
  return useMutation({
    mutationFn: (documentData) => createDocument(documentData),
  });
};

export const useDocumentFile = () => {
  return useMutation({
    mutationFn: (id) => getDocumentFiles(id),
  });
};
export const useDocumentAllFiles = () => {
  return useMutation({
    mutationFn: (ids) => getAllDocumentFiles(ids),
  });
};

export const useAddActivity = () => {
  return useMutation({
    mutationFn: ({ vqa_id, comment }) => addActivity(vqa_id, comment),
  });
};

export const useVQASponsorContactAdmin = () => {
  return useMutation({
    mutationFn: ({ vqaId, sponsorContact }) =>
      VQASponsorContactAdmin(vqaId, sponsorContact),
  });
};
export const useVQAProviderContactAdmin = () => {
  return useMutation({
    mutationFn: ({ vqaId, providerContact }) =>
      VQAProviderContactAdmin(vqaId, providerContact),
  });
};
export const useVQAAssessmentOverviewAdmin = () => {
  return useMutation({
    mutationFn: ({ vqaId, overviewAssessment }) =>
      VQAAssessmentOverviewAdmin(vqaId, overviewAssessment),
  });
};
export const useCreateAuditor = () => {
  return useMutation({
    mutationFn: ({ auditorData }) => createAuditor(auditorData),
  });
};
export const useUpdateteAuditor = () => {
  return useMutation({
    mutationFn: ({ auditorId, auditorData }) =>
      updateAuditor(auditorId, auditorData),
  });
};

export const useAuditorDetails = (id) => {
  return useQuery({
    queryKey: ["auditorDetails"],
    queryFn: () => getAuditorDetails(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useDeleteAuditor = () => {
  return useMutation({
    mutationFn: (auditorId) => deleteAuditor(auditorId),
  });
};

export const useGetprovidersListForProviderDetails = () => {
  return useQuery({
    queryKey: ["providersdetails"],
    queryFn: () => getProvidersListForProviderDetails(),
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useUpdateBackendAssessmentDetails = () => {
  return useMutation({
    mutationFn: ({ vqaId, vqaData }) =>
      updateBackendAssessmentDetails(vqaId, vqaData),
  });
};

export const useGetAdditionalScopeOptions = () => {
  return useQuery({
    queryKey: ["additionalScopeOptions"],
    queryFn: () => getAdditionalScopeOptions(),
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useGetVQARequestDetailsAdmin = (id) => {
  return useQuery({
    queryKey: ["vqaRequestDetailAdmin", id],
    queryFn: () => getVQARequestDetailsAdmin(id),
    enabled: Boolean(id),
    staleTime: 0,
    gcTime: 0,
  });
};

export const useGetAssessmentRequestContactsByVqa = (vqaId) => {
  return useQuery({
    queryKey: ["assessmentRequestContactsByVqa", vqaId],
    queryFn: () => getAssessmentRequestContactsByVqa(vqaId),
    enabled: Boolean(vqaId),
    staleTime: 0,
    cacheTime: 0,
  });
};
export const useGetVQAtDetailsAdmin = (id) => {
  return useQuery({
    queryKey: ["vqatDetailAdmin"],
    queryFn: () => getVQADetailsAdmin(id),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useGetAssessmenttDetails = (id) => {
  return useQuery({
    queryKey: ["assessmenttDetail", id],
    queryFn: () => getAssessmentDetails(id),
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useGetJoinVQADetails = (id) => {
  return useQuery({
    queryKey: ["joinVqaDetail", id],
    queryFn: () => getJoinVAQDetails(id),
    staleTime: 0,
    cacheTime: 0,
  });
};
export const useGetJoinVQARequestDetails = (id) => {
  return useQuery({
    queryKey: ["joinVqaRequestDetail", id],
    queryFn: () => getJoinVAQRequestDetails(id),
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useJoinVqaRequest = () => {
  return useMutation({
    mutationFn: ({
      id,
      additional_info,
      selected_services,
      desired_initial_draft_date,
      provider_contacts,
    }) =>
      joinVqaRequest(
        id,
        additional_info,
        selected_services,
        desired_initial_draft_date,
        provider_contacts
      ),
  });
};

/** Admin's per-join Details instance (pending review or confirmed sub-request). */
export const useGetJoinVQARequestDetailsAdmin = (id, options = {}) => {
  return useQuery({
    queryKey: ["joinVqaRequestDetailAdmin", id],
    queryFn: () => getJoinVQARequestDetailsAdmin(id),
    enabled: options.enabled ?? Boolean(id),
    staleTime: 0,
    cacheTime: 0,
  });
};

/** All-or-nothing confirm of a pending join's requested add-on scope. */
export const useConfirmAddOnScope = () => {
  return useMutation({
    mutationFn: (id) => confirmAddOnScope(id),
  });
};

/** Admin edit-save on a confirmed join sub-request's own scope. */
export const useUpdateJoinVqaScope = () => {
  return useMutation({
    mutationFn: ({ id, updateJoinVqaScopeDto }) =>
      updateJoinVqaScope(id, updateJoinVqaScopeDto),
  });
};
export const useGetVQAParticipantsList = (id, params = {}) => {
  const { current_page = 1, page_size = 10, status } = params;
  return useQuery({
    queryKey: ["vqaParticipantsList", id, current_page, page_size, status ?? null],
    queryFn: () => getVQAParticipantsList(id, { current_page, page_size, status }),
    enabled: Boolean(id),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useAcceptVqaRequest = () => {
  return useMutation({
    mutationFn: ({ id }) => acceptVqaRequest(id),
  });
};
export const useRejectVqaRequest = () => {
  return useMutation({
    mutationFn: ({ id }) => rejectVqaRequest(id),
  });
};
export const useGetAllRequestedAssesmentList = (
  currentPage,
  auditor,
  provider,
  status,
  services,
  sponsor
) => {
  return useQuery({
    queryKey: [
      "allvqalistadmin",
      currentPage,
      auditor,
      provider,
      status,
      services,
      sponsor,
    ],
    queryFn: () =>
      getAllRequestedAssesmentList(
        currentPage,
        auditor,
        provider,
        status,
        services,
        sponsor
      ),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useGetAssesmentRequestDetails = (id) => {
  return useQuery({
    queryKey: ["assessmentRequestDetail", id],
    queryFn: () => getAssesmentRequestDetails(id),
    staleTime: 0,
    cacheTime: 0,
  });
};
export const useGenerateQuestionnaire = () => {
  return useMutation({
    mutationFn: (payload) => generateQuestionnaire(payload),
  });
};

export const useGetInitialBotResponse = (id) => {
  return useQuery({
    queryKey: ["initialBotResponse", id],
    queryFn: () => getInitialBotResponse(id),
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useSendQuestionResponse = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ questionId, answer }) =>
      sendQuestionResponse(questionId, answer),
    onSuccess: async (data, variables) => {
      // Invalidate and refetch the questionnaire data
      await queryClient.invalidateQueries(["initialBotResponse"]);

      // Call the onSuccess callback if provided
      if (options.onSuccess) {
        await options.onSuccess(data, variables);
      }
    },
    onError: (error) => {
      console.error("Failed to send response:", error);
      if (options.onError) {
        options.onError(error);
      }
    },
  });
};

export const useGenerateAudit = () => {
  return useMutation({
    mutationFn: ({ id }) => generateAudit(id),
    onError: (error) => {
      console.error("Failed to send response:", error);
    },
  });
};

export const useGetAllBackendUserList = (currentPage, search_text, sortOptions) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDirection = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: ["getAllBackendUserList", currentPage, search_text, sortBy, sortDirection],
    queryFn: () => getAllBackendUserList(currentPage, search_text, sortOptions),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useAddBackendUser = () => {
  return useMutation({
    mutationFn: (userData) => addBackendUser(userData),
  });
};

export const useGetBackendUserDetails = (id) => {
  return useQuery({
    queryKey: ["backendUserDetails", id],
    queryFn: () => getBackendUserDetails(id),
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useUpdateBackendUser = () => {
  return useMutation({
    mutationFn: ({ id, userData }) => updateBackendUser(id, userData),
  });
};

export const useGetAllSponsorUserList = ({
  currentPage,
  id,
  search_text,
  page_size = 21,
  sortOptions,
  filters,
}) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDirection = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: ["getAllSponsorUserList", id, currentPage, search_text, sortBy, sortDirection, filters],
    queryFn: () =>
      getAllSponsorUserList({
        currentPage,
        id,
        search_text,
        page_size,
        sortOptions,
        filters,
      }),
    staleTime: 0,
    cacheTime: 0,
    enabled: id != null && id !== "",
  });
};
export const useGetAllSponsorUsersList = ({ currentPage, userSearchQuery, sortOptions, filters }) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDirection = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: ["getAllSponsorUsersList", currentPage, userSearchQuery, sortBy, sortDirection, filters],
    queryFn: () => getAllSponsorUsersList({ currentPage, userSearchQuery, sortOptions, filters }),
    staleTime: 0,
    cacheTime: 0,
  });
};

/**
 * Sponsor user profile hook
 * Optimized for role switching - data cached for 5 minutes to prevent refetch storms
 */
export const useLoggedInGetSponsorUserDetails = (role) => {
  return useQuery({
    queryKey: ["sponsorUserProfile", role],
    queryFn: () => {
      if (!["Sponsor Master User", "Sponsor User"].includes(role)) {
        return Promise.reject(new Error("Unsupported sponsor role for profile"));
      }
      return getSponsorUserProfile();
    },
    staleTime: 1000 * 60 * 5, // 5 minutes - prevents refetch during role switch
    cacheTime: 1000 * 60 * 10, // 10 minutes cache
    enabled: ["Sponsor Master User", "Sponsor User"].includes(role),
  });
};

export const useUpdateSponsorUserMfaStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => updateSponsorUserMfaStatus(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sponsorUserProfile"] });
    },
  });
};

export const useUpdateProviderUserMfaStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => updateProviderUserMfaStatus(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorsMe"] });
    },
  });
};

export const useUpdateProviderUserLoggedIn = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => updateProviderUserProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorsMe"] });
      queryClient.invalidateQueries({ queryKey: ["providerUsersByProviderId"] });
    },
  });
};

export const useUpdateBackendUserMfaStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => updateBackendUserMfaStatus(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myProfile"] });
    },
  });
};

export const useGetSponsorUserDetails = (id) => {
  return useQuery({
    queryKey: ["sponsorUserDetails"],
    queryFn: () => getSponsorUserDetails(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id,
  });
};

export const useUpdateSponsorUserLoggedIn = (isSponsorMaster = false) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => updateSponsorUserProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["sponsorUserProfile"]);
    },
  });
};

export const useAddSponsorUser = () => {
  return useMutation({
    mutationFn: (userData) => addSponsorUser(userData),
  });
};

export const useUpdateSponsorUser = () => {
  return useMutation({
    mutationFn: ({ id, userData }) => updateSponsorUser(id, userData),
  });
};
export const useUpdateProviderUsers = () => {
  return useMutation({
    mutationFn: ({ id, userData }) => updateProviderUser(id, userData),
  });
};

export const useGetMyProfile = () => {
  return useQuery({
    queryKey: ["myProfile"],
    queryFn: getMyProfile,
  });
};

export const useUpdateMyProfile = () => {
  return useMutation({
    mutationFn: (userData) => updateMyProfile(userData),
  });
};

export const useGetSponsorMasterUsers = (pageSize, currentPage) => {
  return useQuery({
    queryKey: ["sponsorMasterUsers", pageSize, currentPage],
    queryFn: () => getSponsorMasterUsers({ pageSize, currentPage }),
  });
};

export const useGetSponsorMasterUserDetails = (id) => {
  return useQuery({
    queryKey: ["sponsorMasterUser", id],
    queryFn: () => getSponsorMasterUserDetails(id),
    enabled: !!id,
  });
};

export const useAddSponsorMasterUser = () => {
  return useMutation({
    mutationFn: (userData) => addSponsorMasterUser(userData),
  });
};

export const useUpdateSponsorMasterUser = () => {
  return useMutation({
    mutationFn: ({ id, userData }) => updateSponsorMasterUser(id, userData),
  });
};

export const useGetProviderMasterUsers = (currentPage, pageSize = 10) => {
  return useQuery({
    queryKey: ["provider-master-users", currentPage, pageSize],
    queryFn: () => getProviderMasterUsers(currentPage, pageSize),
    staleTime: 0, // Setting to 0 to ensure fresh data on each query
    cacheTime: 0, // Setting to 0 to prevent caching
  });
};

export const useCreateProviderMasterUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userData) => createProviderMasterUser(userData),
    onSuccess: () => {
      // Invalidate and refetch the provider master users list
      queryClient.invalidateQueries(["provider-master-users"]);
    },
  });
};

export const useDeleteBackendUser = () => {
  return useMutation({
    mutationFn: (id) => deleteBackendUser(id),
  });
};
export const useDeleteSponsorMasterUser = () => {
  return useMutation({
    mutationFn: (id) => deleteSponsorMasterUser(id),
  });
};
export const useDeleteSponsorUser = () => {
  return useMutation({
    mutationFn: (id) => deleteSponsorUser(id),
  });
};

export const useGetProviderMasterUserDetails = (id) => {
  return useQuery({
    queryKey: ["provider-master-user", id],
    queryFn: () => getProviderMasterUserDetails(id),
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useUpdateProviderMasterUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, userData }) => updateProviderMasterUser(id, userData),
    onSuccess: () => {
      // Invalidate and refetch the provider master users list
      queryClient.invalidateQueries(["provider-master-users"]);
    },
  });
};

export const useDeleteProviderMasterUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteProviderMasterUser(id),
    onSuccess: () => {
      // Invalidate and refetch the provider master users list
      queryClient.invalidateQueries(["provider-master-users"]);
    },
  });
};

// export const useRequestCancelAssessment = () => {
//   return useMutation({
//     mutationFn: (vqaRequestId) => requestCancelAssessment(vqaRequestId),
//   });
// };
// export const useCancelAssessment = () => {
//   return useMutation({
//     mutationFn: (vqaId) => CancelAssessment(vqaId),
//   });
// };

export const useCancelAssessment = () => {
  return useMutation({
    mutationFn: ({ vqaId, sponsor, reason }) =>
      CancelAssessment(vqaId, sponsor, reason),
  });
};

// Custom hook that uses react-query to fetch sponsors
export const useGetAllSponsorsForAdmin = (payload, enabled = true) => {
  return useQuery({
    queryKey: ["sponsors", payload],
    queryFn: () => getAllSponsorsForAdmin(payload),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    enabled: enabled,
  });
}; // Custom hook using react-query for fetching sponsor details
export const useGetParentsponsorDetails = (id) => {
  return useQuery({
    queryKey: ["sponsorsDetails", id],
    queryFn: () => getParentSponsorDetails(id),
    enabled: Boolean(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
}; // Custom hook using react-query for fetching sponsor details

export const useCreateSponsor = () => {
  return useMutation({
    mutationFn: ({ data }) => createSponsor(data),
  });
};

export const useCreateSponsorAdminDualRole = () => {
  return useMutation({
    mutationFn: ({ data }) => createSponsorAdminDualRole(data),
  });
};

// Add this new query hook to queries.js
export const useGetProvidersPaginated = ({
  pageSize = 10,
  currentPage = 1,
  providerIdFilter = [],
  rfiTemplateIdFilter = [],
}) => {
  return useQuery({
    queryKey: [
      "providers-paginated",
      pageSize,
      currentPage,
      providerIdFilter,
      rfiTemplateIdFilter,
    ],
    queryFn: () =>
      getProvidersPaginated({
        pageSize,
        currentPage,
        providerIdFilter,
        rfiTemplateIdFilter,
      }),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useCreateProvider = () => {
  return useMutation({
    mutationFn: (providerData) => createProvider(providerData),
  });
};

export const useUpdateProviderBasicProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateProviderBasicProfile(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(["provider-basic-profile", id]);
    },
  });
};

export const useUpdateProviderCompanyProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateProviderCompanyProfile(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(["provider-company-profile", id]);
    },
  });
};

export const useUpdateProviderEmail = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateProviderEmail(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(["provider-basic-profile", id]);
      queryClient.invalidateQueries(["provider-company-profile", id]);
    },
  });
};

export const useCreateProviderUser = () => {
  return useMutation({
    mutationFn: ({ providerData }) => createProviderUser(providerData),
  });
};

export const useCreateProviderDualRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerData) => createProviderDualRole(providerData),
    onSuccess: () => {
      queryClient.invalidateQueries(["sponsors"]);
      queryClient.invalidateQueries(["providerDetailsWithUsers"]);
    },
  });
};

export const useCreateProviderDualRoleFromProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerData) =>
      createProviderDualRoleFromProvider(providerData),
    onSuccess: () => {
      queryClient.invalidateQueries(["sponsors"]);
      queryClient.invalidateQueries(["providers"]);
      queryClient.invalidateQueries(["providerDetailsWithUsers"]);
    },
  });
};

export const useUpdateProviderOrg = () => {
  return useMutation({
    mutationFn: ({ id, providerData }) => updateProviderOrg(id, providerData),
  });
};

export const useUpdateProviderUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, userData }) => {
      // TODO: Uncomment when API is ready
      // return updateProviderUser(id, userData);
      return Promise.resolve({ success: true });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["provider-users"]);
      queryClient.invalidateQueries(["provider-user-details"]);
    },
  });
};

export const useUpdateProviderUserRolesPermissions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, roleData }) =>
      updateProviderUserRolesPermissions(id, roleData),
    onSuccess: () => {
      queryClient.invalidateQueries(["provider-user-details"]);
      queryClient.invalidateQueries(["providerDetailsWithUsers"]);
    },
  });
};

export const useUpdateProviderUserRolesPermissionsForProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, roleData }) =>
      updateProviderUserRolesPermissionsForProvider(id, roleData),
    onSuccess: () => {
      queryClient.invalidateQueries(["provider-user-details"]);
      queryClient.invalidateQueries(["providerDetailsWithUsers"]);
    },
  });
};

export const useGetProviderUserDetails = (id) => {
  return useQuery({
    queryKey: ["provider-user-details", id],
    queryFn: () => {
      // TODO: Uncomment when API is ready
      // return getProviderUserDetails(id);

      // Return mock data for testing
      return Promise.resolve({
        email: "user@example.com",
        first_name: "John",
        last_name: "Doe",
        company_url: "https://example.com",
        phone_number: "123456789",
        office_phone_number: "987654321",
        contact_preference: "Email",
        provider_id: "PROV123",
      });
    },
    enabled: !!id,
  });
};

export const useDeleteProviderUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => {
      // TODO: Uncomment when API is ready
      // return deleteProviderUser(id);
      return Promise.resolve({ success: true });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["provider-users"]);
    },
  });
};

export const useUpdateSponsorUserDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, userData }) => updateSponsorUserDetails(id, userData),
    onSuccess: () => {
      // Invalidate and refetch the provider master users list after success
      queryClient.invalidateQueries(["provider-master-users"]);
      // Pages that add users read the sponsor's settings from these, VQA only among them.
      queryClient.invalidateQueries({ queryKey: ["sponsors"] });
      queryClient.invalidateQueries({ queryKey: ["sponsorsDetails"] });
    },
  });
};
export const useGetSponsorDetails = (id) => {
  return useQuery({
    queryKey: ["sponsors", id],
    queryFn: () => getSponsorDetails(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    enabled: !!id,
    // Authorization failures are definitive; retrying only delays the error
    // state and leaves Manage Account looking like an empty form for longer.
    retry: (failureCount, error) =>
      error?.response?.status !== 403 && failureCount < 2,
  });
}; // Custom hook using react-query for fetching sponsor details

export const useGetSponsorsDetails = (sponsorId, orgId) => {
  return useQuery({
    queryKey: ["sponsors_details", sponsorId, orgId],
    queryFn: () => getSponsorsDetails(sponsorId, orgId),
    enabled: !!sponsorId || !!orgId,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};
export const useDeleteSponsorUserDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteSponsorUserDetails(id), // Pass only `id`
    onSuccess: () => {
      // Invalidate and refetch the provider master users list after success
      queryClient.invalidateQueries(["provider-master-users"]);
    },
  });
};

export const useMetrics = (id, { enabled = true } = {}) => {
  return useQuery({
    queryKey: ["metrics", id],
    queryFn: () => userMetrics(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    enabled: enabled && id != null && id !== "",
  });
};
export const useListOfPurchaseVendors = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["ListOfPurchaseVendors"],
    queryFn: () => listPurchaserVendors(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    enabled,
  });
};
export const useListOfQuestionnaireTemplate = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["QuestionnaireTemplate"],
    queryFn: () => listOfQuestionnaireTemplate(),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
    enabled,
  });
};

/** Diligent Admin: avoids `questionnaire_templates` 401 (sponsor flow) and HC token path for sponsor users. */
export const useListOfQuestionnaireTemplateForAdmin = () => {
  return useQuery({
    queryKey: ["QuestionnaireTemplate", "admin"],
    queryFn: () => listOfQuestionnaireTemplateForAdmin(),
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useCreatePurchaseVendors = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ data }) => createPurchaseVendors(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
      queryClient.invalidateQueries({ queryKey: ["search-providers"] });
    },
  });
};
export const useSendRfiToPurchaseVendor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => sendRfiToPurchaseVendor(id, data),
    onSuccess: () => {
      invalidateRfiRequestActionQueries(queryClient);
    },
  });
};

export const useGetMyRfis = (
  currentPage,
  pageSize,
  searchQuery,
  provider,
  templates,
  status,
  services,
  vendors,
  sortOptions,
  sortFetchNonce = 0,
  dueDateFilter = null
) => {
  return useQuery({
    queryKey: [
      "getMyRfis",
      currentPage,
      pageSize,
      searchQuery,
      provider,
      templates,
      status,
      services,
      vendors,
      sortOptions?.orderBy ?? null,
      sortOptions?.sortDirection ?? null,
      sortFetchNonce,
      dueDateFilter,
    ],
    queryFn: () =>
      getRfis(
        currentPage,
        pageSize,
        searchQuery,
        provider,
        templates,
        status,
        services,
        vendors,
        sortOptions || {},
        dueDateFilter
      ),
    staleTime: 0,
    cacheTime: 0,
  });
};

/** Fetches all pages of user RFIs (no template filter) for building complete templates dropdown */
export const useGetMyRfisAllPages = (
  searchQuery,
  provider,
  status,
  services,
  vendors
) => {
  return useQuery({
    queryKey: [
      "getMyRfisAllPages",
      searchQuery,
      provider,
      status,
      services,
      vendors,
    ],
    queryFn: () =>
      getMyRfisAllPages(searchQuery, provider, status, services, vendors),
    staleTime: 5 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  });
};

/** Diligent Admin: uses `admin/get_rfis` (sponsor `get_rfis` requires sponsor_id in JWT). */
export const useGetMyRfisAllPagesAdmin = (
  searchQuery,
  provider,
  status,
  services,
  vendors,
  sponsorIdList = []
) => {
  return useQuery({
    queryKey: [
      "getMyRfisAllPagesAdmin",
      searchQuery,
      provider,
      status,
      services,
      vendors,
      sponsorIdList,
    ],
    queryFn: () =>
      getAdminRfisAllPages(
        searchQuery,
        provider,
        status,
        services,
        sponsorIdList,
        100
      ),
    staleTime: 5 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  });
};

export const useGetVendorRfis = (
  currentPage,
  pageSize,
  searchQuery,
  sponsor,
  provider,
  docType,
  status,
  services,
  providers,
  sortOptions,
  sortFetchNonce = 0,
  enabled = true,
  dueDateFilter = null
) => {
  return useQuery({
    queryKey: [
      "getVendorRfis",
      currentPage,
      pageSize,
      searchQuery,
      sponsor,
      provider,
      docType,
      status,
      services,
      providers,
      sortOptions?.orderBy ?? null,
      sortOptions?.sortDirection ?? null,
      sortFetchNonce,
      dueDateFilter,
    ],
    queryFn: () =>
      getVendorRfis(
        currentPage,
        pageSize,
        searchQuery,
        sponsor,
        provider,
        docType,
        status,
        services,
        providers,
        sortOptions,
        dueDateFilter
      ),
    staleTime: 0,
    cacheTime: 0,
    enabled,
  });
};

/** Provider /RFI/Requests: all pages, no template filter, for Templates dropdown. */
export const useGetVendorRfisAllPages = (
  searchQuery = "",
  sponsor = [],
  provider = [],
  docType = [],
  status = []
) => {
  const sponsorKey = JSON.stringify([...(sponsor || [])].sort());
  const providerKey = JSON.stringify([...(provider || [])].sort());
  const docTypeKey = JSON.stringify([...(docType || [])].sort());
  const statusKey = JSON.stringify([...(status || [])].sort());
  return useQuery({
    queryKey: [
      "getVendorRfisAllPages",
      searchQuery,
      sponsorKey,
      providerKey,
      docTypeKey,
      statusKey,
    ],
    queryFn: () =>
      getVendorRfisAllPages(
        searchQuery,
        sponsor,
        provider,
        docType,
        status
      ),
    staleTime: 5 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  });
};

export const useGetMyRfisAdmin = (
  currentPage,
  searchQuery,
  provider,
  templates,
  status,
  services,
  sponsor_id_list,
  sortOptions,
  sortFetchNonce = 0,
  dueDateFilter = null
) => {
  return useQuery({
    queryKey: [
      "getRfisAdmin",
      currentPage,
      searchQuery,
      provider,
      templates,
      status,
      services,
      sponsor_id_list,
      sortOptions?.orderBy ?? null,
      sortOptions?.sortDirection ?? null,
      sortFetchNonce,
      dueDateFilter,
    ],
    queryFn: () =>
      getRfisAdmin(
        currentPage,
        searchQuery,
        provider,
        templates,
        status,
        services,
        sponsor_id_list,
        sortOptions || {},
        dueDateFilter
      ),
    structuralSharing: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
  });
};

export const useListOfProviderLocations = (id) => {
  return useQuery({
    queryKey: ["ProviderLocations", id],
    queryFn: () => getProvidersLocation(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    enabled: !!id, // Prevents query execution when `id` is undefined or null
  });
};
/** Open VQQ requests for one vendor, for the one-open-request-per-template rule (US 14958). */
export const useGetOpenVqqRequests = (providerId) => {
  return useQuery({
    queryKey: ["openVqqRequests", providerId],
    queryFn: () => listOpenVqqRequestsForProvider(providerId),
    staleTime: 0,
    enabled: !!providerId,
  });
};
export const useGetPurchaseVendorBySponsor = (id) => {
  return useQuery({
    queryKey: ["PurchaseVendorBySponsor", id],
    queryFn: () => getPurchaseVendorBySponsor(id),
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    enabled: !!id, // Prevents query execution when `id` is undefined or null
  });
};
export const useGetRFIsDetails = (id) => {
  return useQuery({
    queryKey: ["rfisdetails", id],
    queryFn: () => getRFIsDetails(id),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
    enabled: !!id, // Prevents query execution when `id` is undefined or null
  });
};

// The backend keeps the count two minutes, so a page refresh within that window adds nothing.
export const useGetSupportingDocumentCount = (questionnaireId, enabled = true) => {
  return useQuery({
    queryKey: ["supportingDocumentCount", questionnaireId],
    queryFn: () => getSupportingDocumentCount(questionnaireId),
    staleTime: 2 * 60_000,
    enabled: !!questionnaireId && enabled,
  });
};

export const useGetRfiQuestionnaireSnapshot = (questionnaireId, enabled = true) => {
  return useQuery({
    queryKey: ["rfiSnapshot", questionnaireId],
    queryFn: () => getRfiSnapshot(questionnaireId),
    staleTime: Infinity,
    cacheTime: 5 * 60_000,
    enabled: !!questionnaireId && enabled,
  });
};

export const useGetRfiScoredSnapshot = (
  rfiQuestionnaireId,
  { runId, publishedOnly = false, enabled = true } = {}
) => {
  return useQuery({
    queryKey: ["rfiScoredSnapshot", rfiQuestionnaireId, runId ?? "latest", publishedOnly ? "published" : "any"],
    queryFn: () => getRfiScoredSnapshot(rfiQuestionnaireId, { runId, publishedOnly }),
    staleTime: 60_000,
    cacheTime: 5 * 60_000,
    enabled: !!rfiQuestionnaireId && enabled,
  });
};

/**
 * 14030 — Active Risk Scoring Methodology. Carries the verbatim anchored 1-5
 * definitions for Impact / Likelihood / Detectability + RAG thresholds, so the
 * per-question Risk Panel can render methodology tooltips without re-shipping
 * the copy. Long cache (5 min staleTime, 15 min cacheTime) since the
 * methodology row changes rarely.
 */
export const useGetRiskMethodology = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["riskMethodology", "active"],
    queryFn: () => getRiskMethodology(),
    staleTime: 5 * 60_000,
    cacheTime: 15 * 60_000,
    enabled,
  });
};

/**
 * 14031 — Admin SME-override mutation. Optimistically updates the scored
 * snapshot row in the cache so the FE renders the new tier / notes
 * immediately, then invalidates on settle so the next refetch reconciles.
 */
export const usePatchSmeOverride = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ snapshotId, payload }) => patchSmeOverride(snapshotId, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["rfiScoredSnapshot"] });
      // The summaries grid doesn't change until publish; no need to invalidate.
    },
  });
};

/**
 * 14031 — Publish-with-validation mutation. Returns `{ ok, validation? }`
 * so the caller can react to a 422 without throwing. On success, invalidates
 * the scored snapshot + grid summaries cache so the publish state propagates.
 */
export const usePublishRunWithValidation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ scoringRunId, requireGapText, mode }) =>
      publishRunWithValidation(scoringRunId, { requireGapText, mode }),
    onSuccess: (result) => {
      if (result?.ok) {
        queryClient.invalidateQueries({ queryKey: ["rfiScoredSnapshot"] });
        queryClient.invalidateQueries({ queryKey: ["riskSummaries"] });
      }
    },
  });
};

/**
 * 14031 — Unpublish (retract) a scoring run. Same cache invalidation as
 * publish so the sponsor / vendor view reverts to "no risk surface yet"
 * on the next read.
 */
export const useUnpublishRun = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ scoringRunId }) => unpublishRun(scoringRunId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rfiScoredSnapshot"] });
      queryClient.invalidateQueries({ queryKey: ["riskSummaries"] });
    },
  });
};

/**
 * 14032 — Custom risk model list (admin authoring page + picker scope filter).
 * Pass templateId + sponsorId to scope to a (template, sponsor) pair.
 */
export const useListCustomRiskModels = (
  { templateId, sponsorId, includeInactive } = {},
  { enabled = true } = {}
) =>
  useQuery({
    queryKey: ["customRiskModels", { templateId, sponsorId, includeInactive }],
    queryFn: () => listCustomRiskModels({ templateId, sponsorId, includeInactive }),
    staleTime: 30_000,
    cacheTime: 5 * 60_000,
    enabled,
  });

/**
 * 14032 — Single custom risk model (editor view). Cached short — the editor
 * Save flow invalidates this exact key.
 */
export const useGetCustomRiskModel = (customRiskModelId, { enabled = true } = {}) =>
  useQuery({
    queryKey: ["customRiskModel", customRiskModelId],
    queryFn: () => getCustomRiskModel(customRiskModelId),
    staleTime: 0,
    cacheTime: 5 * 60_000,
    enabled: !!customRiskModelId && enabled,
  });

/**
 * 14032 — Create custom risk model. Returns { ok, data?, conflict?, message? }
 * so callers can react to 409 without throwing.
 */
export const useCreateCustomRiskModel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => createCustomRiskModel(payload),
    onSuccess: (result) => {
      if (result?.ok) {
        queryClient.invalidateQueries({ queryKey: ["customRiskModels"] });
      }
    },
  });
};

/**
 * 14032 — Update name + overrides on an existing model. Same 409 envelope as
 * create.
 */
export const useUpdateCustomRiskModel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ customRiskModelId, payload }) => updateCustomRiskModel(customRiskModelId, payload),
    onSuccess: (result, vars) => {
      if (result?.ok) {
        queryClient.invalidateQueries({ queryKey: ["customRiskModels"] });
        queryClient.invalidateQueries({ queryKey: ["customRiskModel", vars.customRiskModelId] });
      }
    },
  });
};

/**
 * 14032 — Delete (soft or hard depending on referencing runs).
 */
export const useDeleteCustomRiskModel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (customRiskModelId) => deleteCustomRiskModel(customRiskModelId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customRiskModels"] });
    },
  });
};

/**
 * 14032 — Drives the model picker on VQQ Details. Returns Diligent Risk
 * Model + active custom models scoped to (template, sponsor).
 */
export const useAvailableRiskModelsForVqq = (rfiQuestionnaireId, { enabled = true } = {}) =>
  useQuery({
    queryKey: ["availableRiskModels", rfiQuestionnaireId],
    queryFn: () => getAvailableRiskModelsForVqq(rfiQuestionnaireId),
    staleTime: 30_000,
    cacheTime: 5 * 60_000,
    enabled: !!rfiQuestionnaireId && enabled,
  });

/**
 * 14032 — Stage a model selection on the VQQ. Does NOT trigger a rescore;
 * the FE shows a "Rescore" button after a successful selection-stage.
 * Invalidates the picker query so the new is_selected flag reflects.
 */
export const useSelectRiskModelForVqq = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ rfiQuestionnaireId, customRiskModelId }) =>
      selectRiskModelForVqq(rfiQuestionnaireId, customRiskModelId),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ["availableRiskModels", vars.rfiQuestionnaireId] });
    },
  });
};

/**
 * Ephemeral preview. Score the VQQ as if a different model were active and
 * return the snapshot, persisting nothing. The caller holds the result in
 * local state and renders it in place of the published snapshot with a
 * preview banner. Nothing to invalidate. The published run is untouched, so
 * dismissing the preview just drops the local state.
 */
export const usePreviewRiskModelForVqq = () =>
  useMutation({
    mutationFn: ({ rfiQuestionnaireId, customRiskModelId }) =>
      previewRiskModelForVqq(rfiQuestionnaireId, customRiskModelId),
  });

/**
 * Trigger Airtable rubric sync. Returns the report on success;
 * invalidates templates + custom-models so the admin sees fresh template
 * names + question counts the moment the sync lands.
 */
export const useSyncRubricFromAirtable = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => syncRubricFromAirtable(),
    onSuccess: (result) => {
      if (result?.ok) {
        queryClient.invalidateQueries({ queryKey: ["diligentRiskTemplates"] });
        // Base I/L/D can change on sync — invalidate the real per-template
        // question key (the editor reads this) so values refresh.
        queryClient.invalidateQueries({ queryKey: ["diligentRiskTemplateQuestions"] });
        queryClient.invalidateQueries({ queryKey: ["customRiskModels"] });
        queryClient.invalidateQueries({ queryKey: ["riskMethodology"] });
      }
    },
  });
};

/**
 * Save edited Diligent Risk Model base values for a template.
 * Invalidates the per-template question cache so both this editor and the
 * Custom Risk Model editor re-read the new base I/L/D.
 */
export const useUpdateDiligentTemplateQuestions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ diligentRiskTemplateId, questions }) =>
      updateDiligentTemplateQuestions(diligentRiskTemplateId, questions),
    onSuccess: (result, variables) => {
      if (result?.ok) {
        queryClient.invalidateQueries({
          queryKey: ["diligentRiskTemplateQuestions", variables.diligentRiskTemplateId],
        });
      }
    },
  });
};

/**
 * 14032 — Diligent Risk Templates list. Cached long; the rubric sync is the
 * only producer and that runs rarely.
 */
export const useListDiligentRiskTemplates = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ["diligentRiskTemplates"],
    queryFn: () => listDiligentRiskTemplates(),
    staleTime: 5 * 60_000,
    cacheTime: 30 * 60_000,
    enabled,
  });

/**
 * 14032 — Per-template question list (id + code + section + base I/L/D)
 * for the Custom Risk Model editor.
 */
export const useListTemplateQuestions = (diligentRiskTemplateId, { enabled = true } = {}) =>
  useQuery({
    queryKey: ["diligentRiskTemplateQuestions", diligentRiskTemplateId],
    queryFn: () => listTemplateQuestions(diligentRiskTemplateId),
    staleTime: 5 * 60_000,
    cacheTime: 30 * 60_000,
    enabled: !!diligentRiskTemplateId && enabled,
  });

/**
 * 14029 — Batch lookup for the Risk Summary grid column. Pass the list of
 * sponsor_rfi_response_ids visible on the current page (after filters), get
 * back a map keyed by id. Pages without summaries (no entitlement / empty list)
 * pass enabled=false to skip the network call entirely.
 */
export const useRiskSummariesByIds = (sponsorRfiResponseIds, { enabled = true } = {}) => {
  const ids = Array.isArray(sponsorRfiResponseIds)
    ? sponsorRfiResponseIds.filter(Boolean)
    : [];
  // Sort the cache key so two re-renders with the same ids in different order share a cache slot.
  const cacheKey = [...ids].sort().join(",");
  return useQuery({
    queryKey: ["riskSummariesByIds", cacheKey],
    queryFn: () => getRiskSummariesByIds(ids),
    staleTime: 30_000,
    cacheTime: 5 * 60_000,
    enabled: enabled && ids.length > 0,
  });
};

export const useRequestRemediation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ questionnaireId, reason }) =>
      postRequestRemediation(questionnaireId, { reason }),
    onSuccess: (_, { questionnaireId }) => {
      qc.invalidateQueries({ queryKey: ["rfisdetails"] });
      qc.invalidateQueries({ queryKey: ["rfiSnapshot", questionnaireId] });
    },
  });
};
export const useSponsorRFIMetrics = ({ enabled = true, sponsorId = null } = {}) => {
  return useQuery({
    queryKey: ["sponsorRFIMetrics", sponsorId],
    queryFn: () => sponsorRFIMetrics(sponsorId),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
    enabled: enabled,
  });
};
export const useProviderTotalCount = () => {
  return useQuery({
    queryKey: ["providerTotalCount"],
    queryFn: () => providerTotalCount(),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useTotalAssessment = () => {
  return useQuery({
    queryKey: ["totalAssessment"],
    queryFn: () => totalAssessment(),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useTotalSponsorCount = () => {
  return useQuery({
    queryKey: ["totalSponsorCount"],
    queryFn: () => sponsorTotalCount(),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useTotalRFIs = () => {
  return useQuery({
    queryKey: ["totalRFIs"],
    queryFn: () => totalRFIs(),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useProviderRFIMetrics = ({ enabled = true, providerId = null } = {}) => {
  return useQuery({
    queryKey: ["providerRFIMetrics", providerId],
    queryFn: () => providerRFIMetrics(providerId),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
    enabled: enabled,
  });
};
export const useProviderAssessmentMetrics = ({ enabled = true, providerId = null } = {}) => {
  return useQuery({
    queryKey: ["providerAssessmentMetrics", providerId],
    queryFn: () => providerAssessmentMetrics(providerId),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
    enabled: enabled,
  });
};
export const useAssessmentMetrics = ({ enabled = true, sponsorId = null } = {}) => {
  return useQuery({
    queryKey: ["assessmentMetrics", sponsorId],
    queryFn: () => assessmentMetrics(sponsorId),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
    enabled: enabled,
  });
};
// 13876 Autorelease — eligibility query + action mutation.
// Eligibility result is cached aggressively because it depends on relatively stable inputs
// (vendor's past Complete submissions + HC template metadata, which the BE caches 1 min).
export const useGetAutoreleaseEligibility = (sponsorRfiResponseId, enabled = true) => {
  return useQuery({
    queryKey: ["autoreleaseEligibility", sponsorRfiResponseId],
    queryFn: () => getAutoreleaseEligibility(sponsorRfiResponseId),
    staleTime: 60_000,
    cacheTime: 5 * 60_000,
    enabled: !!sponsorRfiResponseId && enabled,
  });
};

export const useAutoreleaseVqq = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ sponsorRfiResponseId, pastSponsorRfiResponseId }) =>
      postAutorelease(sponsorRfiResponseId, {
        past_sponsor_rfi_response_id: pastSponsorRfiResponseId,
      }),
    onSuccess: (_data, { sponsorRfiResponseId }) => {
      qc.invalidateQueries({ queryKey: ["rfisdetails"] });
      qc.invalidateQueries({ queryKey: ["rfiSnapshot"] });
      qc.invalidateQueries({ queryKey: ["myRfis"] });
      qc.invalidateQueries({
        queryKey: ["autoreleaseEligibility", sponsorRfiResponseId],
      });
    },
  });
};

export const useGetClientSecrets = () => {
  return useQuery({
    queryKey: ["clientSecrets"],
    queryFn: () => getClientSecrets(),
    staleTime: 0, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

/** Grids/menus that share VQQ cancel-reactivate actions (My VQQs, Library Requests, Document Library, etc.). */
const invalidateRfiRequestActionQueries = (queryClient) => {
  [
    "getMyRfis",
    "getMyRfisAdmin",
    "getVendorRfis",
    "allDocumentsList",
    "allDocumentsRequestList",
    "allDocumentsRequestListadmin",
    "allDocumentsRequestListAllPagesForServicesFilter",
    "rfisdetails",
    "documentDetails",
    "openVqqRequests",
  ].forEach((queryKey) => {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  });
};


export const useUpdateVqqVendorContacts = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sponsorRfiResponseId, contacts }) =>
      updateVqqVendorContacts(sponsorRfiResponseId, contacts),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rfisdetails"] });
      queryClient.invalidateQueries({ queryKey: ["rfiactivity"] });
    },
  });
};

export const useUpdateVqqSponsorContacts = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sponsorRfiResponseId, contacts }) =>
      updateVqqSponsorContacts(sponsorRfiResponseId, contacts),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rfisdetails"] });
      queryClient.invalidateQueries({ queryKey: ["rfiactivity"] });
    },
  });
};

export const useResendVqqContactInvites = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sponsorRfiResponseId, contact_type, emails }) =>
      resendVqqContactInvites(sponsorRfiResponseId, { contact_type, emails }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rfiactivity"] });
    },
  });
};

export const useUpdateVqaVendorContacts = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, contacts }) => updateVqaVendorContacts(id, contacts),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vqaDetails"] });
      queryClient.invalidateQueries({ queryKey: ["vqaactivity"] });
      queryClient.invalidateQueries({ queryKey: ["vqaRequestDetailAdmin"] });
      queryClient.invalidateQueries({ queryKey: ["vqatDetailAdmin"] });
    },
  });
};

export const useUpdateVqaSponsorContacts = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, contacts, sponsor_id }) =>
      updateVqaSponsorContacts(id, contacts, sponsor_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vqaDetails"] });
      queryClient.invalidateQueries({ queryKey: ["vqaactivity"] });
      queryClient.invalidateQueries({ queryKey: ["vqaRequestDetailAdmin"] });
      queryClient.invalidateQueries({ queryKey: ["vqatDetailAdmin"] });
    },
  });
};

export const useResendVqaContactInvites = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, contact_type, emails, sponsor_id }) =>
      resendVqaContactInvites(id, { contact_type, emails, sponsor_id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vqaactivity"] });
    },
  });
};

export const useResendQuestionnaire = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => resendQuestionnaire(id),
    onSuccess: () => {
      invalidateRfiRequestActionQueries(queryClient);
    },
  });
};

export const useActivateQuestionnaire = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => activateQuestionnaire(id),
    onSuccess: () => {
      invalidateRfiRequestActionQueries(queryClient);
      queryClient.invalidateQueries({ queryKey: ["rfiactivity"] });
    },
  });
};

export const useCancelQuestionnaireRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, sponsorRfiResponseId }) =>
      cancelQuestionnaireRequest({ id, sponsorRfiResponseId }),
    onSuccess: () => {
      invalidateRfiRequestActionQueries(queryClient);
    },
  });
};

// Diversity Classification
export const useProviderDiversityClassification = () => {
  return useQuery({
    queryKey: ["providerDiversityClassification"],
    queryFn: providerDiversityClassification,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

// Certifications
export const useProviderCertifications = () => {
  return useQuery({
    queryKey: ["providerCertifications"],
    queryFn: providerCertifications,
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

// Geographic Region
export const useProviderGeographicRegion = () => {
  return useQuery({
    queryKey: ["providerGeographicRegion"],
    queryFn: providerGeographicRegion,
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

// Affiliated Organization
export const useProviderAffiliatedOrganization = () => {
  return useQuery({
    queryKey: ["providerAffiliatedOrganization"],
    queryFn: providerAffiliatedOrganization,
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

// Languages
export const useProviderLanguages = () => {
  return useQuery({
    queryKey: ["providerLanguages"],
    queryFn: providerLanguages,
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};
export const useGetProviderOrgDetails = (id) => {
  return useQuery({
    queryKey: ["providerOrgDetails", id],
    queryFn: () => getProviderOrgDetails(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id, // Prevents query execution when `id` is undefined or null
  });
};
export const useGetAllProviderOrg = (pageSize, currentPage, searchText, sortOptions) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDirection = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: ["providerOrg", pageSize, currentPage, searchText, sortBy, sortDirection],
    queryFn: () => getAllProviderOrg(pageSize, currentPage, searchText, sortOptions),
    staleTime: 0,
    cacheTime: 0,
  });
};
export const useGetAllProviderUsers = (pageSize, currentPage, searchText, sortOptions, filters) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDirection = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: ["providerUsers", currentPage, searchText, sortBy, sortDirection, filters],
    queryFn: () =>
      getAllProviderUsers(pageSize, currentPage, searchText, sortOptions, filters),
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useGetAllProviderUsersByProviderId = (
  providerId,
  pageSize = 21,
  currentPage = 1,
  searchText = "",
  sortOptions = undefined,
  filters = undefined
) => {
  const sortBy = sortOptions?.orderBy ?? null;
  const sortDirection = sortOptions?.sortDirection ?? null;
  return useQuery({
    queryKey: [
      "providerUsersByProviderId",
      providerId,
      currentPage,
      searchText,
      sortBy,
      sortDirection,
      filters,
    ],
    queryFn: () =>
      getAllProviderUsersByProviderId(
        providerId,
        pageSize,
        currentPage,
        searchText,
        sortOptions,
        filters
      ),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!providerId,
  });
};

export const useGetListForProviderUserDetails = (id) => {
  return useQuery({
    queryKey: ["providerUsersdetails", id],
    queryFn: () => getProvidersListForProviderUserDetails(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id,
  });
};
export const useGetListForProviderTherapeutic = () => {
  return useQuery({
    queryKey: ["providersListForTherapeutic"],
    queryFn: () => getProvidersListForTherapeutic(),
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};
export const useGetListForSponsorFilters = () => {
  return useQuery({
    queryKey: ["sponsorFilters"],
    queryFn: () => getSponsorsFilter(),
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

export const useGetProviderDetailsWithUsers = (providerId, orgId) => {
  return useQuery({
    queryKey: ["providerDetailsWithUsers", providerId, orgId],
    queryFn: () => getProviderDetailsWithUsers(providerId, orgId),
    enabled: !!providerId && !!orgId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useGetProviderAllData = (providerId) => {
  return useQuery({
    queryKey: ["providerAllData", providerId],
    queryFn: () => getProviderAllData(providerId),
    enabled: !!providerId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAcceptVendorQuestionnaire = () => {
  return useMutation({
    mutationFn: ({ questionnaire_id, data }) =>
      acceptVendorQuestionnaire(questionnaire_id, data),
  });
};
export const useExportQuestionnaireExcel = () => {
  return useMutation({
    mutationFn: (data) => exportQuestionnaireExcel(data),
  });
};

export const useDownloadExportFile = () => {
  return useMutation({
    mutationKey: ["downloadExportFile"],
    mutationFn: ({ folder, questionnaire_name }) =>
      downloadExportFile(folder, questionnaire_name),
  });
};

export const useDownloadExportDocs = () => {
  return useMutation({
    mutationKey: ["downloadExportDocs"],
    mutationFn: ({
      folder,
      questionnaire_name,
      exclude_response_base_name,
    }) =>
      downloadExportDocs(
        folder,
        questionnaire_name,
        exclude_response_base_name,
      ),
  });
};

export const useLegacyAttachmentAvailability = (
  folder,
  response_base_name,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["legacyAttachmentAvailability", folder, response_base_name],
    queryFn: () =>
      getLegacyAttachmentAvailability(folder, response_base_name),
    enabled: !!enabled && !!folder && !!response_base_name,
    staleTime: 1000 * 60 * 5,
  });
};

export const usePollExportStatus = (exportLogsId, { enabled = false } = {}) => {
  return useQuery({
    queryKey: ["exportStatus", exportLogsId],
    queryFn: () => getExportStatus(exportLogsId),
    enabled: !!exportLogsId && enabled,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === "Completed" || status === "Error") return false;
      return 2000;
    },
    staleTime: 0,
    cacheTime: 0,
  });
};

/**
 * First time sign-in check for Provider users
 * Optimized staleTime/cacheTime to prevent refetch during role switching
 */
export const useGetFirstTimeSignIn = (isSignedIn, userRole) => {
  return useQuery({
    queryKey: ["firstTimeSignIn"],
    queryFn: getFirstTimeSignin,
    staleTime: 1000 * 60 * 5, // 5 minutes - prevents refetch during role switch
    cacheTime: 1000 * 60 * 10, // 10 minutes cache
    enabled: !!isSignedIn && userRole === "Provider User",
  });
};

/**
 * Vendor/Provider user details hook
 * Optimized for role switching - data cached for 5 minutes to prevent refetch storms
 */
export const useGetVendorsMe = (userRole) => {
  return useQuery({
    queryKey: ["vendorsMe"],
    queryFn: getVendorsMe,
    staleTime: 1000 * 60 * 5, // 5 minutes - prevents refetch during role switch
    cacheTime: 1000 * 60 * 10, // 10 minutes cache
    enabled:
      userRole === "Provider User" || userRole === "Provider Master User",
  });
};

export const useAcceptTerms = () => {
  return useMutation({
    mutationKey: ["acceptTerms"],
    mutationFn: (id) => acceptTerms(id),
  });
};
export const useHypercomplyLogout = () => {
  return useMutation({
    mutationKey: ["hypercomplyLogout"],
    mutationFn: (data) => hypercomplyLogout(data),
  });
};

export const useSupportingDocsExportVQA = () => {
  return useMutation({
    mutationKey: ["supportingDocs"],
    mutationFn: ({ entityId, entityType }) =>
      supportingDocsExportVQA(entityId, entityType),
  });
};

export const useCheckProvidersRequiredFields = (role) => {
  return useQuery({
    queryKey: ["checkProvidersRequiredFields", role],
    queryFn: () => checkProvidersRequiredFields(),
    enabled: role === "Provider User" || role === "Provider Master User",
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useGetSponsorCount = (id) => {
  return useQuery({
    queryKey: ["sponsorCount", id],
    queryFn: () => getSponsorCount(id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!id,
  });
};

export const useGetProviderCounts = () => {
  return useQuery({
    queryKey: ["providerCounts"],
    queryFn: getProviderCounts,
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });
};

export const useProviderDocumentCounts = ({ enabled = true, providerId = null, sponsorId = null } = {}) => {
  return useQuery({
    queryKey: ["providerDocumentCounts", providerId, sponsorId],
    queryFn: () => getProviderDocumentCountsByIds(providerId ? [providerId] : [], sponsorId),
    staleTime: 0,
    cacheTime: 0,
    enabled: enabled && !!providerId,
  });
};

export const useGetRfiResponse = () => {
  return useMutation({
    mutationFn: (rfiResponseId) => getRfiResponse(rfiResponseId),
  });
};

export const useGetRfiResponseFile = () => {
  return useMutation({
    mutationFn: ({ rfiResponseId, extension }) =>
      getRfiResponseFile(rfiResponseId, extension),
  });
};

export const useGetTAIndicationsData = (pagination, filters) => {
  return useQuery({
    queryKey: ["getTAIndicationsData", pagination, filters],
    queryFn: () => getTAIndicationsData(pagination, filters),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useGTASummaryData = (pagination, filters) => {
  return useQuery({
    queryKey: ["getTASummaryData", pagination, filters],
    queryFn: () => getTASummaryData(pagination, filters),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};
export const useUpdateTokenRole = () => {
  return useMutation({
    mutationFn: ({ id, role, sub_role, rights }) =>
      updateTokenRole(id, role, sub_role, rights),
  });
};

export const useGetChatHistory = () => {
  return useQuery({
    queryKey: ["getChatHistory"],
    queryFn: () => getChatHistory(),
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useSendChat = () => {
  return useMutation({
    mutationFn: ({ sessionId, userPrompt }) => sendChat({ sessionId, userPrompt }),
  });
};

export const useUpdateChatName = () => {
  return useMutation({
    mutationFn: ({ sessionId, title }) => updateChatName({ sessionId, title }),
  });
};

export const useGetChatMessages = ({ sessionId }) => {
  return useQuery({
    queryKey: ["getChatMessages", sessionId],
    queryFn: () => getChatMessages({ sessionId }),
    enabled: !!sessionId,
    staleTime: 0, // 10 minutes
    cacheTime: 0, // 30 minutes
  });
};

export const useAddProviderContact = () => {
  return useMutation({
    mutationFn: ({ email, first_name, last_name, job_title, provider_id, organization_id, ...data }) =>
      addProviderContact({ email, first_name, last_name, job_title, provider_id, organization_id, ...data }),
  });
};

export const useAddProviderLocation = () => {
  return useMutation({
    mutationFn: ({ provider_id, location }) =>
      addProviderLocation(provider_id, location),
  });
};

export const useGetRequestMetrics = () => {
  return useQuery({
    queryKey: ["requestMetrics"],
    queryFn: getRequestMetrics,
    staleTime: 60 * 1000,
  });
};

export const useMakeRequestContact = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ provider_user_id, request_contact_status, category }) =>
      makeRequestContact({ provider_user_id, request_contact_status, category }),
    onSuccess: () => {
      queryClient.invalidateQueries(["providerUsersByProviderId"]);
      queryClient.invalidateQueries(["providerUsers"]);
    },
  });
};

export const useMakePrimaryContact = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ provider_id, provider_user_id, category }) =>
      makePrimaryContact({ provider_id, provider_user_id, category }),
    onSuccess: () => {
      queryClient.invalidateQueries(["providerUsersByProviderId"]);
      queryClient.invalidateQueries(["providerUsers"]);
    },
  });
};

export const useActivateOrDeactivateProviderUserContact = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ provider_user_id, is_active }) =>
      activateOrDeactivateProviderUserContact({ provider_user_id, is_active }),
    onSuccess: () => {
      queryClient.invalidateQueries(["providerUsersByProviderId"]);
      queryClient.invalidateQueries(["providerUsers"]);
    },
  });
};

export const useActivateOrDeactivateSponsorUserContact = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sponsor_user_id, is_active }) =>
      activateOrDeactivateSponsorUserContact({ sponsor_user_id, is_active }),
    onSuccess: () => {
      queryClient.invalidateQueries(["sponsorUsersBySponsorId"]);
      queryClient.invalidateQueries(["sponsorMasterUsers"]);
      queryClient.invalidateQueries(["getAllSponsorUserList"]);
      queryClient.invalidateQueries(["getAllSponsorUsersList"]);
    },
  });
};

export const useHideOrShowFromDiscovery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ provider_id, is_visible }) =>
      hideOrShowFromDiscovery({ provider_id, is_visible }),
    onSuccess: () => {
      queryClient.invalidateQueries(["providerOrg"]);
    },
  });
};

export const useActivateOrDeactivateProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ provider_id, is_active }) =>
      activateOrDeactivateProvider({ provider_id, is_active }),
    onSuccess: () => {
      queryClient.invalidateQueries(["providerOrg"]);
    },
  });
};

export const useActivateOrDeactivateSponsor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sponsor_id, is_active }) =>
      activateOrDeactivateSponsor({ sponsor_id, is_active }),
    onSuccess: () => {
      queryClient.invalidateQueries(["sponsors"]);
    },
  });
};

export const useMyVendorsQuery = (sponsorId = null) => {
  return useQuery({
    queryKey: ["myVendors", sponsorId],
    queryFn: () => getMyVendors(sponsorId),
    enabled: !!sponsorId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};

export const useAddManualMyVendorMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerId) => addManualMyVendor(providerId, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myVendors", sponsorId] });
    },
  });
};

export const useRemoveManualMyVendorMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerId) => removeManualMyVendor(providerId, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myVendors", sponsorId] });
    },
  });
};

const refreshMyVendorsQuery = async (queryClient, sponsorId) => {
  await queryClient.invalidateQueries({ queryKey: ["myVendors", sponsorId] });
  await queryClient.refetchQueries({ queryKey: ["myVendors", sponsorId], type: "active" });
};

export const useHideMyVendorMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerId) => hideMyVendor(providerId, sponsorId),
    onSuccess: () => refreshMyVendorsQuery(queryClient, sponsorId),
  });
};

export const useUnhideMyVendorMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerId) => unhideMyVendor(providerId, sponsorId),
    onSuccess: () => refreshMyVendorsQuery(queryClient, sponsorId),
  });
};

export const useBookmarkedVendorsQuery = (sponsorId = null) =>
  useQuery({
    queryKey: ["bookmarkedVendors", sponsorId],
    queryFn: () => getBookmarkedVendors(sponsorId),
    enabled: !!sponsorId,
    staleTime: 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => (data?.provider_ids || []).map(String),
  });

/** Live provider name/logo/services keyed by id — used to label the Bookmarked list. */
export const useProviderSummariesByIdsQuery = (providerIds = []) => {
  const ids = [...new Set((providerIds || []).map(String).filter(Boolean))];
  return useQuery({
    queryKey: ["providerSummariesByIds", ids.slice().sort().join(",")],
    queryFn: async () => {
      const response = await get_providers.getAllProvider({
        current_page: 1,
        page_size: Math.max(ids.length, 1),
        provider_id_list: ids,
      });
      return (response?.items || [])
        .map((item) => ({
          id: String(item.Id || item.id || ""),
          name: item.name || "",
          logoUrl: item.logo || item.Logo || null,
          serviceCategories: (item.provider_capabilities || [])
            .map((cap) => cap.rfi_name || cap.name)
            .filter(Boolean),
        }))
        .filter((item) => item.id);
    },
    enabled: ids.length > 0,
    staleTime: 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};

export const useAddBookmarkedVendorMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerId) => addBookmarkedVendor(providerId, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookmarkedVendors", sponsorId] });
    },
  });
};

export const useRemoveBookmarkedVendorMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerId) => removeBookmarkedVendor(providerId, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookmarkedVendors", sponsorId] });
    },
  });
};

export const useSponsorVendorTags = (sponsorId = null) => {
  return useQuery({
    queryKey: ["sponsorVendorTags", sponsorId],
    queryFn: () => getSponsorVendorTags(sponsorId),
    staleTime: 1000 * 30,
    retry: false,
    refetchOnWindowFocus: false,
  });
};

function rebuildAllKnownTags(vendorTagsMap) {
  const set = new Set();
  Object.values(vendorTagsMap || {}).forEach((tags) => {
    (tags || []).forEach((tag) => {
      if (tag) set.add(tag);
    });
  });
  return Array.from(set).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
}

export const useSetVendorTags = (sponsorId = null) => {
  const queryClient = useQueryClient();
  const queryKey = ["sponsorVendorTags", sponsorId];

  return useMutation({
    mutationFn: ({ providerId, tags }) =>
      setVendorTagsForProvider(providerId, tags, sponsorId),
    onMutate: async ({ providerId, tags }) => {
      await queryClient.cancelQueries({ queryKey });
      const previous = queryClient.getQueryData(queryKey);
      queryClient.setQueryData(queryKey, (old) => {
        if (!old) return old;
        const key = String(providerId);
        const nextVendorTags = { ...(old.vendor_tags || {}), [key]: tags };
        return {
          ...old,
          vendor_tags: nextVendorTags,
          all_known_tags: rebuildAllKnownTags(nextVendorTags),
        };
      });
      return { previous };
    },
    onError: (_err, _vars, context) => {
      if (context?.previous) {
        queryClient.setQueryData(queryKey, context.previous);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
};

export const useSponsorNotificationUsers = (sponsorId = null) =>
  useQuery({
    queryKey: ["sponsorNotificationUsers", sponsorId],
    queryFn: () => getSponsorNotificationUsers(sponsorId),
    enabled: !!sponsorId,
    staleTime: 30 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });

export const useSetSponsorNotificationUsers = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => setSponsorNotificationUsers(payload, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["sponsorNotificationUsers", sponsorId],
      });
    },
  });
};

export const useVendorListsQuery = (sponsorId = null) =>
  useQuery({
    queryKey: ["vendorLists", sponsorId],
    queryFn: () => getVendorLists(sponsorId),
    enabled: !!sponsorId,
    staleTime: 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });

export const useCreateVendorListMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => createVendorList(payload, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorLists", sponsorId] });
    },
  });
};

export const useUpdateVendorListMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ listId, payload }) => updateVendorList(listId, payload, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorLists", sponsorId] });
    },
  });
};

export const useDuplicateVendorListMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (listId) => duplicateVendorList(listId, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorLists", sponsorId] });
    },
  });
};

export const useAddVendorListMembersMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ listId, payload }) => addVendorListMembers(listId, payload, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorLists", sponsorId] });
    },
  });
};

export const useDeleteVendorListMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (listId) => deleteVendorList(listId, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorLists", sponsorId] });
    },
  });
};

export const useRemoveVendorListMemberMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ listId, providerId }) => removeVendorListMember(listId, providerId, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorLists", sponsorId] });
    },
  });
};

export const useReorderVendorListMembersMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ listId, payload }) => reorderVendorListMembers(listId, payload, sponsorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendorLists", sponsorId] });
    },
  });
};

export const useSystemListMemberOrderQuery = (sponsorId, systemListKind, enabled = true) => {
  return useQuery({
    queryKey: ["systemListMemberOrder", sponsorId, systemListKind],
    queryFn: () => getSystemListMemberOrder(systemListKind, sponsorId),
    enabled: Boolean(sponsorId && systemListKind && enabled),
    staleTime: 30_000,
  });
};

export const useReorderSystemListMembersMutation = (sponsorId = null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ systemListKind, payload }) =>
      reorderSystemListMembers(systemListKind, payload, sponsorId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["systemListMemberOrder", sponsorId, variables.systemListKind],
      });
    },
  });
};